import { adminHeaders } from './auth';
import { marketplaceHeaders } from './marketplaceAuth';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export async function fetchAccessoryCategories() {
  const response = await fetch(`${API_URL}/accessories/categories`);
  if (!response.ok) {
    throw new Error(`Error fetching accessory categories: ${response.statusText}`);
  }
  return response.json();
}

export async function fetchAccessories(filters = {}) {
  const params = new URLSearchParams();

  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      params.append(key, value);
    }
  });

  const response = await fetch(`${API_URL}/accessories?${params.toString()}`, {
    headers: marketplaceHeaders(),
  });
  if (!response.ok) {
    throw new Error(`Error fetching accessories: ${response.statusText}`);
  }
  return response.json();
}

export async function fetchSellerAccessories() {
  return fetchAccessories({ sellerOnly: "true" });
}

export async function fetchAccessory(id) {
  const response = await fetch(`${API_URL}/accessories/${id}`);
  if (!response.ok) throw new Error(`Error fetching accessory: ${response.statusText}`);
  return response.json();
}

export async function recordAccessoryView(id) {
  const response = await fetch(`${API_URL}/accessories/${id}/view`, { method: "POST" });
  if (!response.ok) throw new Error("Unable to record accessory view.");
  return response.json();
}

export async function createAccessory(accessory) {
  const response = await fetch(`${API_URL}/accessories`, {
    method: 'POST',
    headers: {
      ...adminHeaders(),
      ...marketplaceHeaders(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(accessory),
  });

  if (!response.ok) {
    throw new Error(`Error creating accessory: ${response.statusText}`);
  }
  return response.json();
}

export async function updateAccessory(id, accessory) {
  const response = await fetch(`${API_URL}/accessories/${id}`, {
    method: 'PUT',
    headers: {
      ...adminHeaders(),
      ...marketplaceHeaders(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(accessory),
  });

  if (!response.ok) {
    throw new Error(`Error updating accessory: ${response.statusText}`);
  }
  return response.json();
}

export async function deleteAccessory(id) {
  const response = await fetch(`${API_URL}/accessories/${id}`, {
    method: 'DELETE',
    headers: { ...adminHeaders(), ...marketplaceHeaders() },
  });

  if (!response.ok) {
    throw new Error(`Error deleting accessory: ${response.statusText}`);
  }
  return true;
}